const publicAssetsDirectory = `${process.env.PUBLIC_URL}/assets`;

const buttonBackgroundsLocation = `${publicAssetsDirectory}/buttonBackgrounds`;
const errorCodeTitlesLocation = `${publicAssetsDirectory}/errorCodeTitles`;
const flagsLocation = `${publicAssetsDirectory}/flags`;
const scribblesLocation = `${publicAssetsDirectory}/scribbles`;

const assetLocations = {
    buttonBackgrounds: {
        primary: `${buttonBackgroundsLocation}/bg_button.png`,
        secondary: `${buttonBackgroundsLocation}/bg_button_secondary.png`,
        white: `${buttonBackgroundsLocation}/bg_button_white.png`,
        disabled: `${buttonBackgroundsLocation}/bg_button_inactive.png`,
    },
    errorCodeTitles: {
        404: `${errorCodeTitlesLocation}/title_404.png`,
    },
    flags: {
        AU: `${flagsLocation}/australia.png`,
        AT: `${flagsLocation}/austria.png`,
        BE: `${flagsLocation}/belgium.png`,
        CA: `${flagsLocation}/canada.png`,
        DK: `${flagsLocation}/denmark.png`,
        FI: `${flagsLocation}/finland.png`,
        FR: `${flagsLocation}/france.png`,
        DE: `${flagsLocation}/germany.png`,
        IT: `${flagsLocation}/italy.png`,
        NL: `${flagsLocation}/netherlands.png`,
        NZ: `${flagsLocation}/newzealand.png`,
        NO: `${flagsLocation}/norway.png`,
        PL: `${flagsLocation}/poland.png`,
        ES: `${flagsLocation}/spain.png`,
        SE: `${flagsLocation}/sweden.png`,
        CH: `${flagsLocation}/switzerland.png`,
        GB: `${flagsLocation}/unitedKingdom.png`,
        US: `${flagsLocation}/unitedStates.png`,
    },
    scribbles: {
        v1: `${scribblesLocation}/scribble_v1.png`,
        v2: `${scribblesLocation}/scribble_v2.png`,
        v3: `${scribblesLocation}/scribble_v3.png`,
    },
};

export default assetLocations;
